import Lottie from 'lottie-react';

import celebrate from '../jsons/celebrate.json';

const Celebrate = props => {
  return <Lottie animationData={celebrate} {...props} />;
};

export default Celebrate;
